<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>
    Are you sure you want to {{ data.suspension.Resolved ? 'unresolve' : 'resolve' }} this suspension?
  </span>

  <ng-container actions *ngIf="uiState === uiStateEnumForTemplate.ShowData">
    <button mat-button
            *ngIf="!data.suspension.Resolved"
            data-testid="confirm-resolve-suspension-button"
            (click)="resolveSuspension()">
      Resolve
    </button>

    <button mat-button
            *ngIf="data.suspension.Resolved"
            data-testid="confirm-unresolve-suspension-button"
            (click)="unresolveSuspension()">
      Unresolve
    </button>
  </ng-container>
</app-dialog-base>
